import Vue from 'vue';
import App from './App.vue';//新添加的3行
import './assets/less/index.less';
import 'element-ui/lib/theme-chalk/index.css';
import 'default-passive-events';//Added non-passive event listener to ascroll- blocking 'mousewheel'event Consider marking event handler as ' passive'to make the page more responsive
import utils from "@/common/index";
import router from './router';
import store from './store';

import * as mobileApi from '@/network/mobileApi';
import XLSX from 'xlsx';
import {
  Button,
  Radio,
  Container,
  Main,
  Header,
  Aside,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Card,
  Table,
  TableColumn,
  Breadcrumb,
  BreadcrumbItem,
  Tag,
  Form,
  FormItem,
  Input,
  InputNumber,
  Select,
  Option,
  Switch,
  DatePicker,
  Dialog,
  Pagination,
  Tooltip,
  Steps,
  Step,
  Divider,
  Scrollbar,
  Descriptions,
  DescriptionsItem,
  Drawer,
  CheckboxGroup,
  Checkbox,
  Tabs,
  TabPane,
  RadioGroup,
  RadioButton,
  Upload,
  Image,
  Link,
  PageHeader,
  Collapse,
  CollapseItem,
  Empty,
  Popover,
  Popconfirm,
  Slider,
  Statistic,
  Progress,
  Tree,
  Timeline,
  TimelineItem,
  Loading,
  Alert,
  OptionGroup,
  ColorPicker,
  Cascader,
  Autocomplete,
  Badge,
  Message, MessageBox
} from 'element-ui';

Vue.use(Button).use(Radio).use(Container).use(Main).use(Header).use(Aside).use(Menu)
  .use(Submenu).use(MenuItemGroup).use(MenuItem).use(Dropdown).use(DropdownMenu)
  .use(DropdownItem).use(Row).use(Col).use(Card).use(Table).use(TableColumn).use(Breadcrumb)
  .use(BreadcrumbItem).use(Tag).use(Form).use(FormItem).use(Input).use(InputNumber)
  .use(Select).use(Option).use(Switch).use(DatePicker).use(Dialog).use(Pagination).use(Tooltip)
  .use(Steps).use(Step).use(Divider).use(Scrollbar).use(Descriptions).use(DescriptionsItem).use(Drawer)
  .use(CheckboxGroup).use(Checkbox).use(Tabs).use(TabPane).use(RadioGroup).use(RadioButton).use(Upload)
  .use(Image).use(Link).use(PageHeader).use(Collapse).use(CollapseItem).use(Empty).use(Popover).use(Popconfirm)
  .use(Slider).use(Statistic).use(Progress).use(Tree).use(Timeline).use(TimelineItem).use(Loading).use(Alert).use(OptionGroup).use(ColorPicker).use(Cascader).use(Autocomplete).use(Badge)
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$utils = utils;
Vue.prototype.XLSX = XLSX
Vue.prototype.$api = mobileApi;
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    document.title = 'ERQI 而启-Q7数据大模型系统 - 渐进式企业数据管理平台'
    // 应用初始主题（来自 state 或本地缓存）
    const themeFromState = this.$store.state.user && this.$store.state.user.themeAside
    const themeFromLocal = (() => {
      try { return JSON.parse(localStorage.getItem('theme.aside') || '{}') } catch(e) { return {} }
    })()
    const theme = Object.assign({}, themeFromLocal, themeFromState)
    this.applyAsideTheme(theme)
    // 监听主题变更，实时写入全局 CSS 变量
    this.$store.watch(
      state => state.user && state.user.themeAside,
      (newTheme) => {
        if (newTheme) this.applyAsideTheme(newTheme)
      },
      { deep: true }
    )
  },
  methods: {
    applyAsideTheme(theme = {}) {
      const root = document.documentElement.style
      const map = {
        '--aside-hover-bg': theme.asideHoverBg,
        '--aside-active-bg': theme.asideActiveBg,
        '--aside-active-color': theme.asideActive,
        '--aside-item-radius': theme.asideItemRadius
      }
      Object.keys(map).forEach(k => {
        if (map[k] !== undefined && map[k] !== null && map[k] !== '') {
          root.setProperty(k, map[k])
        }
      })
    }
  }
}).$mount('#app')
